import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { activities } from '../data/activities';
import { useTheme } from '../contexts/ThemeContext';

const Activities: React.FC = () => {
  const { isDarkMode } = useTheme();
  return (
    <div className={`min-h-screen py-32 ${isDarkMode ? 'bg-black' : 'bg-stone-50'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <Link
            to="/blog"
            className={`font-serif inline-block px-4 py-2 rounded mb-6 ${
              isDarkMode ? 'bg-gray-700 text-white hover:bg-gray-600' : 'bg-stone-100 text-stone-900 hover:bg-stone-200'
            } transition duration-200`}
          >
            ← Back to Blog
          </Link>
          <h1 className={`font-serif text-5xl font-normal mb-10 ${isDarkMode ? 'text-white' : 'text-stone-900'}`}>Activities</h1>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {activities.map((activity) => (
              <Link 
                key={activity.id}
                to={`/blog/activities/${activity.id}`}
                className="block"
              >
                <motion.div
                  className={`${isDarkMode ? 'bg-gray-800' : 'bg-white'} border ${isDarkMode ? 'border-gray-700' : 'border-stone-200'} rounded-lg overflow-hidden shadow-lg`}
                  whileHover={{ scale: 1.02 }}
                  transition={{ duration: 0.2 }}
                >
                  {activity.images.length > 0 && (
                    <img
                      src={activity.images[0]}
                      alt={activity.title}
                      className="w-full h-48 object-cover"
                    />
                  )}
                  <div className="p-6">
                    <h2 className={`font-serif text-xl font-normal mb-2 ${isDarkMode ? 'text-white' : 'text-stone-900'}`}>{activity.title}</h2>
                    {activity.subtitle && (
                      <p className={`font-serif ${isDarkMode ? 'text-gray-300' : 'text-stone-500'} mb-2 italic`}>{activity.subtitle}</p>
                    )}
                    <p className={`font-serif ${isDarkMode ? 'text-gray-300' : 'text-stone-500'}`}>
                      {activity.date} • {activity.location}
                    </p>
                  </div>
                </motion.div>
              </Link>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Activities;